import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const device = {
      platform: navigator.platform || "",
      userAgent: navigator.userAgent || "",
      language: navigator.language || "",
      timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone) || "",
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    };
    const tosAccepted = localStorage.getItem("steele_tos_accepted") === "1";
    localStorage.removeItem("steele_tos_accepted");
    axios
      .post(`${API}/auth/google/session`, { session_id: sessionId, tos_accepted: tosAccepted, device }, { withCredentials: true })
      .then((r) => navigate("/portal", { state: { user: r.data }, replace: true }))
      .catch(() => navigate("/portal", { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-steel-bg">
      <div className="flex items-center gap-3 text-steel-secondary">
        <Loader2 className="h-5 w-5 animate-spin text-steel-brass" />
        <span className="font-mono text-xs uppercase tracking-[0.25em]">Signing you in…</span>
      </div>
    </div>
  );
}
